import React from "react";
import { useStateContext } from "../contexts/ContextProvider";

const FooterCTA = () => {
  const { handleShowContact } = useStateContext();

  return (
    <>
      <section id="section14">
        <div className="container-fluid">
          <div className="cta2-relative">
            <div className="cta2">
              <h4>Let's Make</h4>
              <h4>
                <span>Knowledge</span> Simple
              </h4>
              <div className="flex">
                <h4>Together</h4>
                <button onClick={handleShowContact}>Get in touch</button>
              </div>
              <div className="back-circle"></div>
              <div className="back-circle2"></div>
            </div>
            <div className="cta2 mobile">
              <h4>
                Let's Make <span>Knowledge</span> Simple Together
              </h4>
              <button onClick={handleShowContact}>Get in touch</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FooterCTA;
